import { ID_FILTER_SEARCH } from "../constants/StoreFilters";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { addFilter } from "../../../utils/FilterUtils";
import { useSetRecoilState } from "recoil";
import { STATE_STORES_ACTIVE_FILTERS } from "../constants/ClustersRecoil";
import AdvancedFilter from "../../../component/AdvancedFilter";

const StoreFilter = (props: any) => {
    const { t } = useTranslation('finance', { keyPrefix: 'clusters' });
    const setFilterDefs = useSetRecoilState(STATE_STORES_ACTIVE_FILTERS);
    const [search, setSearch] = useState("");

    const schema = Yup.object().shape({
    });

    const defaultValues = {
        code: '',
        name: ''
    };


    const fields = {
    }


    const submit = (data: any) => {
        addFilter(setFilterDefs, ID_FILTER_SEARCH, search);
    }

    const reset = () => {
        setFilterDefs([]);
    }

    return (
            <AdvancedFilter schema={schema} fields={fields} defaultValues={defaultValues}
                            searchInput={search} setSearchInput={setSearch}
                            onSubmit={submit}
                            onReset={reset}
            />
    )

}
export default StoreFilter;